// FORMAT PRODUCT ITEM FOR CART
export function formatCartAdditionalOption(
  option,
  productIdList,
  productQuantityByID,
  productItemIdById,
) {
  let isInCart = false;
  let itemId = "";
  let quantity = 1;
  if (productIdList.includes(option.entity_id)) {
    isInCart = true;
    quantity = productQuantityByID[option.entity_id];
    itemId = productItemIdById[option.entity_id];
  }

  return {
    productId: option.entity_id ?? "",
    itemId: itemId,
    quantity: quantity,
    thumbnail: option.thumbnail ?? "",
    price: option.price ?? false,
    specialPrice: option.special_price ?? false,
    name: option.name ?? "",
    description: option.description ?? "",
    shortDescription: option.short_description,
    entityId: option.item_id ?? "",
    isInCart: isInCart,
  };
}
